module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMVJREFUeNpiZEADfEWrBYBUAhDHA7EBmvQFIF4IxAs+9YV+QJZgRDMkAEjNB2IBBvwAZEgi0LANGAYBDUmAGkIKABm2AG4Q1CXrGcgDgSCXMULD5D6SdxqBEg1oXgbx6/F4U5EJGrA4wwRqET4AjhyQi85jiR1SwQUmKhgCAgYsWAQxwoiYsGIi1kpCYQUKo/9U8BrxLiIU2CSFEZ6wWkiyi7CEFShBLqBGGIGzCKVhBC8ByDXoA9QlC2ACLKTGDq6CDSDAAD2/Rubd8ZP+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/icon/internoticin.png
// module id = oFx5
// module chunks = 1